import { List } from '@mui/material';
import { ColumnKey } from './columnDefs';
import { useColumnOrderDnd } from './useColumnOrderDnd';
import { ColumnOrderRow } from './ColumnOrderRow';

type ColumnOrderListProps = {
  order: ColumnKey[];
  onReorder: (newOrder: ColumnKey[]) => void;
  disabled?: boolean;
};

export function ColumnOrderList({
  order,
  onReorder,
  disabled = false,
}: ColumnOrderListProps) {
  const { closestEdge, setClosestEdge, announceMove } = useColumnOrderDnd(
    order,
    onReorder,
    disabled,
  );

  const moveBy = (index: number, delta: number) => {
    const targetIndex = index + delta;
    if (targetIndex < 0 || targetIndex >= order.length) {
      return;
    }
    const next = [...order];
    const [moved] = next.splice(index, 1);
    next.splice(targetIndex, 0, moved);
    onReorder(next);
    announceMove(order[index], index, targetIndex, next.length);
  };

  return (
    <List sx={{ width: '100%', p: 0 }}>
      {order.map((key, index) => (
        <ColumnOrderRow
          key={key}
          columnKey={key}
          index={index}
          total={order.length}
          disabled={disabled}
          edge={closestEdge[key]}
          onEdgeChange={setClosestEdge}
          onMove={moveBy}
        />
      ))}
    </List>
  );
}
